import { createUseStyles } from '../../theme/theming';
import { colorMixer } from '../../theme/colors';

const buttonStyles = createUseStyles((theme) => ({
  primary: {
    width: ({ fluid } = {}) => (fluid ? '100%' : ''),
    borderRadius: theme?.shape?.borderRadius?.regular,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
    color: ({ disabled } = {}) =>
      disabled
        ? colorMixer(theme?.palette?.background?.default, 0.5).color
        : theme?.colors?.CtaTextColor,
    background: theme?.colors?.ctaColor,
    opacity: ({ disabled } = {}) => (disabled ? 0.5 : 1),
    border: 'none',
    textDecoration: 'none',
    cursor: ({ disabled } = {}) => (disabled ? 'not-allowed' : 'pointer'),
    maxWidth: '100%',
    display: 'inline-block',
    wordBreak: 'break-word',

    flexShrink: '0'
  },
  secondary: {
    width: ({ fluid } = {}) => (fluid ? '100%' : ''),
    borderRadius: theme?.shape?.borderRadius?.regular,
    fontSize: '14px',
    fontWeight: '700',
    display: 'inline-block',
    textDecoration: 'none',
    lineHeight: '18px',
    color: ({ disabled } = {}) =>
      disabled
        ? colorMixer(theme.palette.primary.main, 0.5).color
        : theme?.colors?.CtaTextColor,
    background: theme?.colors?.ctaColor,
    opacity: ({ disabled } = {}) => (disabled ? 0.5 : 1),
    border: ({ disabled } = {}) =>
      disabled
        ? `1px solid ${colorMixer(theme.palette.primary.main, 0.5).color}`
        : `1px solid ${theme?.colors?.ctaColor}`,
    cursor: ({ disabled } = {}) => (disabled ? 'not-allowed' : 'pointer'),
    maxWidth: '100%',
    display: 'inline-block',
    wordBreak: 'break-word',

    flexShrink: '0'
  },
  tertiary: {
    width: ({ fluid } = {}) => (fluid ? '100%' : ''),
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    color: ({ disabled } = {}) =>
      disabled
        ? colorMixer(theme.palette.primary.main, 0.5).color
        : theme.palette.primary.main,
    background: ({ disabled } = {}) =>
      disabled
        ? colorMixer(theme?.palette?.background?.default, 0.5).color
        : theme?.palette?.background?.default,
    cursor: ({ disabled } = {}) => (disabled ? 'not-allowed' : 'pointer'),
    maxWidth: '100%',
    display: 'inline-block',
    wordBreak: 'break-word',
    flexShrink: '0',
    '&:hover': {
      background: theme.palette.primary.lightest,
      borderRadius: '4px'
    },

    '&$active': {
      fontWeight: '700',
      background: theme.palette.primary.lightest,
      borderRadius: theme.shape.borderRadius.small,
      color: theme.palette.primary.main
    }
  },
  anchorClass: {
    textDecoration: 'none'
  },
  active: {},
  large: {
    padding: '20px 24px'
  },
  medium: {
    padding: '16px 24px'
  },

  small: {
    padding: '12px 16px'
  },

  '@media screen and (max-width: 767px)': {
    active: {
      fontWeight: 'initial',
      background: theme?.palette?.background?.default,
      borderRadius: '0',
      color: theme.palette.primary.main
    }
  }
}));

export default buttonStyles;
